import React from 'react';
import styled from 'styled-components';

const ViewUI = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
`;

const TextUI = styled.p`
  border-bottom: 1px solid rgb(206, 204, 204, 0.4);
  padding-bottom: 20px;
  width: 100%;
  font-size: 15.5px;
`;

const ExclusivePrime = () => (
  <ViewUI>
    <TextUI>
      <b>preço exclusivo </b>cliente A.mais
    </TextUI>
  </ViewUI>
);

export default ExclusivePrime;
